export default __webpack_public_path__ + "static/media/89t.0c4972b8.jpg";